module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ack-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/toc#toc-acknowledgements"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page-vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page-vii"
    }
  }, [_vm._v("Since the publication of "), _c('em', [_vm._v("The Anniversary Man")]), _vm._v(" back in 2009, I have been to a great many places – France, America, Dubai, Holland, Canada, the list goes on. I have made a great many friends, amongst them the crews at Sonatine, Overlook and de Fontein, people like Peter and Aaron, Jack and Emer, Veda, George Luca, Francois, Marie M., Marie L., Leonore (my little-big French sister), Arnaud, Xavier, Sophie, Fabienne, Susan, Catrien and Genevieve. In Dubai I was privileged to work with Isobel and her team, and then there were the extraordinary folks at the Southern Festival of Books in Nashville, those in Miami and Chicago and at Bouchercon in Indianapolis. Seems I have had the good fortune to meet some truly great people everywhere I’ve been, and I never cease to marvel at the warmth and generosity extended to me. It is a privilege and an homour to know you all, and to now count you amongst my dearest friends. My sincere thanks go to all of you for making this past year so memorable.")])]), _c('a', {
    attrs: {
      "id": "page-vii"
    }
  }, [_c('p', [_vm._v("As always, my thanks to the team at Orion, to Euan, my agent, and to my own family, whose tolerance of my idiosyncrasies seems limitless.")]), _vm._v(" "), _c('p', [_vm._v("And to you, dear reader, without whom this would all be kind of pointless.")]), _vm._v(" "), _c('p', [_vm._v("Finally I would like to dedicate this book to the memory of Norman ‘Bill’ Bolwell (1938–2009). Bill was a Coldstream Guard, a Detective in the CID, the Anti-Terrorist Unit and in Special Branch; he was an accomplished musician, a wonderful artist, a true friend, and a great man. For a few too-short years he was the closest we ever got to having a father, and my brother and I will miss him greatly.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 75
// module chunks = 0